var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};



















pug_mixins["section"] = pug_interp = function(title, cls){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(attributes, true)) + "\u003E";
if (title) {
pug_html = pug_html + "\u003Cdiv class=\"section-title\" layout-padding\u003E\u003Cdiv" + (pug.attr("class", pug.classes([cls], [true]), false, true)) + "\u003E\u003Ch2\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"content\" layout-padding\u003E\u003Cdiv\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"registration-card\"\u003E\u003Cmd-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cform name=\"vm.registrationForm\" api-form=\"vm.saveAndBeginIdCheck()\" ng-if=\"!vm.checkingIdentity\"\u003E\u003Cfieldset class=\"registration-fields\" ng-disabled=\"!vm.canBeEdited()\"\u003E";
pug_mixins["section"].call({
block: function(){
pug_html = pug_html + "\u003Chelp-box\u003E\u003Ccontent-item content-item-name=\"registration-info-general\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fhelp-box\u003E\u003Cdiv class=\"email-details\" ng-if=\"vm.promptForEmail\"\u003E\u003Cinput-container label=\"Please confirm your email address\"\u003E\u003Cinput required name=\"email\" type=\"email\" ng-model=\"vm.formObject.email\" ng-model-options=\"{ debounce: 500 }\"\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"registration-details\" ng-if=\"vm.formObject.email || !vm.promptForEmail\"\u003E         \u003Cinput-container label=\"Title\" ng-if=\"vm.canBeEdited()\"\u003E\u003Cmd-select class=\"honorifics small-list\" ng-model=\"vm.formObject.honorific\" placeholder=\"Title\" aria-label=\"Title\"\u003E\u003Cmd-option ng-repeat=\"honorific in vm.honorifics\" ng-value=\"honorific\"\u003E{{ honorific }}\u003C\u002Fmd-option\u003E\u003Cmd-option ng-value=\"\"\u003E&mdash;\u003C\u002Fmd-option\u003E\u003C\u002Fmd-select\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Title\" ng-if=\"!vm.canBeEdited()\"\u003E\u003Cinput name=\"honorific\" ng-model=\"vm.formObject.honorific\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"First name\"\u003E\u003Cinput required md-autofocus=\"autofocus\" name=\"firstName\" ng-model=\"vm.formObject.firstName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Middle name\"\u003E\u003Cinput name=\"middleName\" ng-model=\"vm.formObject.middleName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Last name\"\u003E\u003Cinput required name=\"lastName\" ng-model=\"vm.formObject.lastName\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container class=\"phone\" ng-if=\"!vm.bioCheckRequired\" label=\"Mobile Phone (required for security) 04XX XXX XXX\"\u003E\u003Cinput required type=\"tel\" name=\"phone\" ng-model=\"vm.formObject.phone\" pattern=\"^04(\\d *){8}\"\u003E\u003Cng-message when=\"pattern\"\u003EInvalid mobile phone number (e.g. 0412 345 678) \u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cdate-select label=\"Date of birth\" model=\"vm.formObject.dob\" name=\"dob\" max-date=\"vm.eighteenYearsAgo\"\u003E \u003C\u002Fdate-select\u003E\u003Caddress-select name=\"address\" label=\"Residential Address\" address=\"vm.address\" selected-item-change=\"vm.selectedItemChange(item)\" required=\"true\"\u003E\u003C\u002Faddress-select\u003E\u003Cdiv layout-margin layout=\"column\"\u003E\u003Cdiv class=\"politically-exposed\" layout=\"row\" layout-align=\"start center\"\u003E\u003Clabel\u003EI am a Politically Exposed Person (PEP) &nbsp;&nbsp;\u003C\u002Flabel\u003E";
pug_mixins["required-radio-container"].call({
block: function(){
pug_html = pug_html + "\u003Cmd-radio-button ng-value=\"true\" ng-disabled=\"!vm.canBeEdited()\"\u003EYes\u003C\u002Fmd-radio-button\u003E\u003Cmd-radio-button ng-value=\"false\" ng-disabled=\"!vm.canBeEdited()\"\u003ENo &nbsp;&nbsp;\u003C\u002Fmd-radio-button\u003E";
}
}, 'is-politically-exposed',"vm.isPep", true);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.formObject.consent.isPep\"\u003E\u003Cinput-container label=\"Place of Birth\"\u003E\u003Cinput required name=\"placeOfBirth\" ng-model=\"vm.formObject.consent.placeOfBirth\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Occupation\"\u003E\u003Cinput required name=\"occupation\" ng-model=\"vm.formObject.consent.occupation\"\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cmd-checkbox class=\"md-align-top-left\" ng-disabled=\"!vm.canBeEdited()\" required ng-model=\"vm.formObject.consent.hasAuthorisedIdentityCheck\" aria-label=\"Authorise identity check\"\u003E\u003Ccontent-item content-item-name=\"registration-form-hasAuthorisedIdentityCheck\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fmd-checkbox\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cmd-checkbox class=\"md-align-top-left\" ng-disabled=\"!vm.canBeEdited()\" required ng-model=\"vm.formObject.consent.hasAcceptedPolicies\" aria-label=\"Accept policies\"\u003E\u003Ccontent-item content-item-name=\"registration-form-hasAcceptedPolicies\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fmd-checkbox\u003E\u003C\u002Fdiv\u003E\u003Cng-transclude\u003E\u003C\u002Fng-transclude\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"selfie\" ng-switch=\"vm.bioCheckRequired\"\u003E \u003Cdiv class=\"selfie-panel\" ng-switch-when=\"true\"\u003E\u003Cdiv class=\"mobile-verification\"\u003E\u003Ccontent-item content-item-name=\"registration-mobile-verification\"\u003E              \u003C\u002Fcontent-item\u003E\u003C\u002Fdiv\u003E\u003Cinput-container class=\"phone\" label=\"Mobile Phone (required for security) 04XX XXX XXX\"\u003E\u003Cinput required type=\"tel\" name=\"phone\" ng-model=\"vm.formObject.phone\" pattern=\"^04(\\d *){8}\"\u003E\u003Cng-message when=\"pattern\"\u003EInvalid mobile phone number (e.g. 0412 345 678)             \u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cdiv id=\"action\" layout=\"row\" layout-align=\"end start\" ng-if=\"vm.canBeEdited()\"\u003E\u003Cmd-button class=\"md-raised md-accent\" id=\"verify\" type=\"submit\"\u003EVerify Identity            \u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"no-selfie-panel\" ng-switch-when=\"false\"\u003E \u003Cdiv id=\"action\" layout=\"row\" layout-align=\"end start\" ng-if=\"vm.canBeEdited()\"\u003E\u003Cmd-button class=\"md-raised md-accent\" id=\"verify\" type=\"submit\"\u003EVerify Identity    \u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}, 'Identity check', "{{ vm.logoClass }}");
pug_html = pug_html + "\u003C\u002Ffieldset\u003E\u003C\u002Fform\u003E\u003Cdiv layout-padding\u003E\u003Cdiv id=\"assistance\" ng-if=\"vm.checkingIdentity &amp;&amp; vm.recommendAssistance\" layout=\"row\" layout-align=\"start start\"\u003E\u003Cmd-icon flex=\"none\"\u003Eaccount_circle\u003C\u002Fmd-icon\u003E\u003Cp flex=\"100\"\u003E\u003Ccontent-item content-item-name=\"registration-info-identityCheckAssistance\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"greenid\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"verification-incomplete\" ng-if=\"vm.identityNotVerified\"\u003E\u003Cdiv id=\"review\" ng-show=\"vm.isUnderReview()\"\u003E\u003Ch2\u003EIdentity check under review\u003C\u002Fh2\u003E\u003Cp\u003EYour identity could not be confirmed automatically and will need to be reviewed by an administrator. You may continue \nthe application process and we will notify you when the review has been completed.\u003C\u002Fp\u003E\u003Cmd-button class=\"md-raised md-accent\" ng-click=\"vm.proceed()\"\u003EProceed\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003Cdiv id=\"denied\" ng-show=\"vm.denied()\"\u003E\u003Ch2\u003EIdentity check failed\u003C\u002Fh2\u003E\u003Cp\u003E \u003Ccontent-item content-item-name=\"registration-info-denied\"\u003E\u003C\u002Fcontent-item\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;